/**
 * Form-level message. `role="alert"` so it is announced when it appears —
 * a failed sign-in that only changes pixels is invisible to a screen reader.
 */
export default function FormAlert({ children, tone = 'caution' }) {
  if (!children) return null
  return (
    <div className={`form-alert ${tone === 'positive' ? 'positive' : ''}`.trim()} role="alert">
      {children}
    </div>
  )
}
